import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode, forwardRef } from 'react';
import { useWorkspacePadding } from '../hooks/useWorkspacePadding';

interface ScrollableSectionProps {
  children: ReactNode;
  bleed?: boolean;
  sx?: SxProps<Theme>;
  testId?: string;
}

const ScrollableSection = forwardRef<HTMLDivElement, ScrollableSectionProps>(
  ({ children, bleed = true, sx, testId }, ref) => {
    const { padding, isMobile } = useWorkspacePadding();

    return (
      <Box
        ref={ref}
        test-id={testId}
        sx={[
          {
            flex: 1,
            minWidth: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
            ...(bleed && { pr: padding, mr: isMobile ? -padding : -padding + 0.5 }),
            ...(isMobile && {
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': { display: 'none' },
            }),
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {children}
      </Box>
    );
  },
);

export default ScrollableSection;
